import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import PullToRefresh from 'react-simple-pull-to-refresh';
import { UpdateMenuFlag } from "../../actions";
import { LoadSettings } from "../../actions/index";
import { setHeaderTitle } from "../../helpers/header.helper";
import { BurgerMenuIcon } from "../../icon";
import { Setting } from "../../models/settings-model";
import * as selector from '../../selectors/selectors';
import { pageTitles, } from "../shared/constants";
import SettingsRouteComponent from "./settings.route.component";
import { AppRoutes } from "../routes/route.path";

interface Props {
    handleCloseSettings: () => void;
}

const SettingsComponent = (props: Props) => {
    const dispatch = useDispatch();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const Settings: Setting[] = useSelector(selector.settings)
    const [isactiveBlock, setIsactiveBlock] = useState<boolean>(false);
    const [dialogTitle, setDialogTitle] = useState<string>("Settings");
    const [showTime, setShowTime] = useState<boolean>()
    const [showSignature, setShowSignature] = useState<boolean>()
    const [showUnsubscribe, setShowUnsubscribe] = useState<boolean>()
    const [hideMenu, setHideMenu] = useState<boolean>(false);
    const location = useLocation();

    useEffect(() => {
        setHideMenu((location.pathname != AppRoutes.SETTINGS))
    }, [location.pathname])

    useEffect(() => {
        refreshData();
        setHeaderTitle(pageTitles.SETTINGS);

    }, [])

    const refreshData = () => {
        if (!Settings || Settings.length === 0) {
            LoadSettings(dispatch);
        }
    };

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => LoadSettings(dispatch));

    return (
        <>
            {IsMobileDevice ? <><PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh} className='h-auto'>
                <Grid container className={`h-p-95  m-auto o-y-scroll`}>
                    <div className={`${IsMobileDevice ? "w-p-100" : isactiveBlock ? 'w-p-50 settings-paper-border br-2 m-auto paper-background' : showTime || showSignature ? 'w-p-60 settings-paper-border br-2 m-auto paper-background' : 'w-p-50 settings-paper-border br-2 m-auto paper-background'} `}>
                        {(dialogTitle !== "Settings" || IsMobileDevice) && !hideMenu &&
                            <Grid item xs={12}>
                                <div className={`${IsMobileDevice ? " d-flex color-header-title-font" : "d-flex pb-1 h1-semibold color-settings-heading "} ${((isactiveBlock || showUnsubscribe) && IsMobileDevice) ? 'box-shadow-display-background-shadow' : IsMobileDevice ? 'bb-primary-divider-4' : ''} p-1 `}>
                                    {IsMobileDevice &&
                                        <span className="setting-togglebar p-absolute" style={{ zIndex: 100 }}>
                                            <BurgerMenuIcon
                                                onClick={(e) => { e.stopPropagation(); UpdateMenuFlag(dispatch, true) }}
                                            />
                                        </span>
                                    }
                                    <span
                                        className={`${IsMobileDevice ?
                                            "h4-semibold color-header-title-font"
                                            : "h3-semibold color-settings-heading"
                                            } ${dialogTitle === "Settings" && IsMobileDevice ? 'ml-5' : ''} mr-auto my-auto`}>
                                        {dialogTitle}
                                    </span>
                                </div>
                            </Grid>}
                        <div>
                            <SettingsRouteComponent />
                        </div>
                    </div>
                </Grid >

            </PullToRefresh>
            </> :
                // <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh} className='h-auto'>
                <div className={`d-flex bg-color-settings-background h-p-100`}>
                    <SettingsRouteComponent />
                </div>
                // </PullToRefresh>
            }
        </>



    );
}

export default SettingsComponent
